import { supplies_reorder_status } from "@redotech/redo-prisma-client/enums";
import { createEnum } from "@redotech/zod/zod-enum";
import { AccountId, accountIdFormat, ProductId, productIdFormat } from "./ids";

export const SuppliesReorderStatusSchema = createEnum(supplies_reorder_status);

export enum SuppliesInventoryTrackedProductType {
  LABEL_PAPER = "LABEL_PAPER",
  PARCEL_PACKAGING = "PARCEL_PACKAGING",
}

export function getRedoSuppliesAccountInfo(): {
  accountId: AccountId;
  teamId: string;
} {
  if (process.env.NODE_ENV === "production") {
    return {
      accountId: accountIdFormat.write(BigInt("2209160522559597213")),
      teamId: "69334cb38b62ab405f172655",
    };
  } else {
    return {
      accountId: accountIdFormat.write(BigInt("6235023168987770121")),
      teamId: "69af2bf4d7421ff8f485a07b",
    };
  }
}

export function requiresSuppliesInventoryTrackingSetup({
  isOmsEnabled,
  teamId,
  cartProductIds,
}: {
  isOmsEnabled: boolean;
  teamId: string;
  cartProductIds: ProductId[];
}): boolean {
  if (!isOmsEnabled || teamId !== "69a154821c910b9ac2cd4d05") {
    return false;
  }
  const { eligibleInventoryTrackedProducts } =
    getEligibleInventoryTrackedProducts();
  const eligibleProductIds = new Set(
    eligibleInventoryTrackedProducts.map((p) => p.productId),
  );
  return cartProductIds.some((id) => eligibleProductIds.has(id));
}

// These are the supplies products that we sell that are eligible for inventory
// tracking and reordering to be set up
export function getEligibleInventoryTrackedProducts(): {
  eligibleInventoryTrackedProducts: {
    productId: ProductId;
    type: SuppliesInventoryTrackedProductType;
    quantityPerCase: number;
  }[];
} {
  return {
    eligibleInventoryTrackedProducts: [
      {
        productId: productIdFormat.write(BigInt("6956299579183592813")),
        type: SuppliesInventoryTrackedProductType.LABEL_PAPER,
        quantityPerCase: 4000,
      },
    ],
  };
}

export { supplies_reorder_status as SuppliesReorderStatus } from "@redotech/redo-prisma-client/enums";
